import { LuX } from 'react-icons/lu';

import { Button } from '@/components/ui/button';

import { useDockState } from './dock-state';
import { DockItemProps } from './widgets/DockItem';
import { DockItemTitle } from './widgets/DockItemTitle';

export const DockBar = () => {
    const { items } = useDockState();
    return (
        <div className="flex max-w-full gap-2 overflow-auto">
            {items.map((item, index) => (
                <DockItemButton key={index} item={item} />
            ))}
        </div>
    );
};

const DockItemButton = (props: DockItemProps) => {
    const { removeDockItem, setActiveId, activeId } = useDockState();
    const isActive = activeId === props.item.id;
    return (
        <div className="inline-flex rounded-md shadow-sm" role="group">
            <Button
                variant={isActive ? 'default' : 'outline'}
                size="sm"
                className="max-w-[150px] rounded-r-none border-r-0"
                onClick={() => setActiveId(isActive ? null : props.item.id)}
            >
                <DockItemTitle {...props} />
            </Button>
            <Button
                variant={isActive ? 'default' : 'outline'}
                size="sm"
                className="rounded-l-none"
                onClick={() => removeDockItem(props.item.id)}
            >
                <LuX />
            </Button>
        </div>
    );
};
